import {IController, IModule, IOnChangesObject} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import _ from "lodash";
import {BeregnetMøtevarighet, MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {SakRessurs, Sakstidspunkt} from "felles/tjenester/ressurser/SakRessurs";
import {MalmøteRessurs} from "felles/tjenester/ressurser/MalmøteRessurs";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {MøteTjeneste} from "web/moduler/møte/MøteTjeneste";

const css = require('./møtemal.scss');

export class MøtemalKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeMoetemal', {
                bindings: {gruppeId: '<', moetemal: '<', komprimertVisning: '<', vedRediger: '&'},
                controller: MøtemalKontroller.forInjisering(),
                template: require('./møtemal.html')
            });
    }

    static forInjisering() {
        return [
            MøteTjeneste.regNavn,
            MalmøteRessurs.regNavn,
            Kontekst.regNavn,
            MøtemalKontroller
        ]
    }

    constructor(private møteTjeneste: MøteTjeneste,
                private malmøteRes: MalmøteRessurs,
                private kontekst: Kontekst) {
    }

    gruppeId: string; //settes via bindings/$onChanges (gruppeId eller moetemal må være angitt)
    moetemal: l.MalmøteModell; //settes via bindings/$onChanges (gruppeId eller moetemal må være angitt)
    komprimertVisning: boolean; //settes via bindings/$onChanges
    vedRediger: ()=>void; //settes via bindings/$onChanges

    moetedato: l.MøteDato;
    beregnetSluttDato: BeregnetMøtevarighet;
    sakstidspunkter: { [sakId: string]: Sakstidspunkt };

    visDeltakerdetaljer = false;
    visSaksdetaljer: { [sakId: string]: boolean } = {};

    inkludertGenerertDokumentValg: { [verdi: number]: string };
    kanRedigere = false;

    visRedigerMalTips() {
        return this.moetemal &&
            (!this.moetemal.starttidspunkt ||
                !this.moetemal.behandlingsSted ||
                this.moetemal.deltakere.length === 0) &&
            this.kanRedigere
    }

    visRedigerMalsakerTips() {
        return this.moetemal && this.moetemal.saker.length === 0 && this.kanRedigere;
    }

    slutttidspunkt(): string {
        if (!_.isString(this.moetemal.starttidspunkt) || _.isNaN(this.moetemal.varighet)) return '';
        return moment(this.moetemal.starttidspunkt, 'hh:mm').add(this.moetemal.varighet, 'minute').format('hh:mm');
    }

    redigerMal(){
        this.vedRediger();
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'gruppeId', gruppeId => this.init(gruppeId));
        dersomChangesInneholder(changes, 'moetemal', mal => this.initMøtemal(mal));
    }

    //hjelpemetoder

    private init(gruppeId:string) {
        this.gruppeId = gruppeId;
        this.kanRedigere = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.gruppeId)
        this.malmøteRes.hent(this.gruppeId).$promise
            .then(mal => this.initMøtemal(mal));
    }

    private initMøtemal(mal: l.MalmøteModell) {
        this.gruppeId = mal.eiendeGruppeId;
        this.moetemal = mal;
        const startdato = moment(this.moetemal.starttidspunkt, 'hh:mm');
        const møte = {
            dato: {start: startdato.toDate(), slutt: startdato.clone().add(this.moetemal.varighet, 'minute').toDate()},
            saker: mal.saker
        };

        this.moetedato = møte.dato;
        this.beregnetSluttDato = MøteRessurs.beregnetMøtevarighet(møte);
        this.sakstidspunkter = SakRessurs.sakstidspunkter(møte);
        this.inkludertGenerertDokumentValg = this.møteTjeneste.inkluderGenerertDokumentValg();
    }
}

